import api from '../../api/index';
import i18n from '../../i18n';

export default {
  namespaced: true,
  state     : {
    langs: [
      {
        text: 'Русский',
        code: 'ru',
      },
      {
        text: 'English',
        code: 'en',
      },
    ],
    current_lang: localStorage.getItem('lang') || i18n.locale || 'en',
  },
  getters: {
    langs: ({langs}) => langs,
    lang : ({current_lang}) => current_lang,
  },
  mutations: {
    SET_LANG(state, value) {
      state.current_lang = value;
    },
    SET_LANGS(state, value) {
      state.langs = value;
    },
  },
  actions: {
    async update_language({commit}, {lang, serverUpdate = true}) {
      try {
        if (serverUpdate) {
          await api.user.update_language({lang: lang.code});
        }

        commit('SET_LANG', lang);

        i18n.locale = lang.code;
        localStorage.setItem('lang', lang.code);
      } catch (err) {

      }
    },
  },
};
